import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { db, getDoc, getDocs, collection, doc } from '../../firebaseConfiguration';
import './PostDetail.css';
import Footer from '../../components/Footer';
import '@fortawesome/fontawesome-free/css/all.min.css';

const PostDetail = () => {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [posts, setPosts] = useState([]);
    const navigate = useNavigate();

    const getPost = useCallback(async () => {
        const docRef = doc(db, "posts", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setPost(docSnap.data());
            console.log("Document data:", docSnap.data());
        }
    }, [id]);

    const getPosts = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "posts"));
            const postsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPosts(postsData);
            return postsData;
        } catch (error) {
            console.error('Error getting posts:', error);
        } finally {
            console.log('Done getting posts');
        }
    };

    useEffect(() => {
        getPost();
        getPosts();
    }, [id, getPost]);

    useEffect(() => {
        console.log(post);
    }, [post]);

    if (!post) return <div>Loading...</div>;

    return (
        <div className='bg-white'>
            <div style={{ height: '50vh', overflow: 'hidden' }}>
                {/* image cover */}
                <img src={post?.coverImage} alt="cover" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <button className='btn btn-light btn-back' onClick={() => navigate('/knowledge')}>
                    <i className="fas fa-arrow-left"></i>
                    <span className="btn-text">Trở về danh sách</span>
                </button>
            </div>

            <div className='mt-3 px-5'>
                {/* title */}
                <h1
                    style={{
                        width: '100%',
                        fontSize: 'clamp(1.7rem, 4vw, 2.2rem)',
                        fontWeight: 'bold'
                    }}
                    className='text-center mt-3'
                >
                    {post?.title}
                </h1>

                {/* subtitle */}
                <h2
                    style={{
                        width: '100%',
                        fontSize: 'clamp(1.2rem, 2vw, 1.5rem)'
                    }}
                    className='text-center mt-3'
                >
                    {post?.subtitle}
                </h2>

                {/* content 1 */}
                {post?.content1 && (
                    <p
                        style={{
                            width: '100%',
                            fontSize: 'clamp(1.2rem, 2vw, 1.5rem)'
                        }}
                        className='mt-3'
                    >
                        {post?.content1}
                    </p>
                )}

                {/* content 2 */}
                <div className="content-container d-flex gap-4 mt-3">
                    {/* avatar */}
                    <img src={post?.avatar} alt="avatar" className="content-avatar" />
                    {post?.content2 && (
                        <p
                            style={{
                                width: '100%',
                                fontSize: 'clamp(1.2rem, 2vw, 1.5rem)'
                            }}
                        >
                            {post?.content2}
                        </p>
                    )}
                </div>

                {/* content 3 */}
                {post?.content3 && (
                    <p
                        style={{
                            width: '100%',
                            fontSize: 'clamp(1.2rem, 2vw, 1.5rem)'
                        }}
                        className='mt-3'
                    >
                        {post?.content3}
                    </p>
                )}

                {/* tên và ngày tháng (date: Timestamp {seconds: 1735633831, nanoseconds: 780000000}) */}
                <p
                    style={{
                        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                        margin: '0',
                        textAlign: 'right'
                    }}
                >
                    An Classical
                </p>

                <p
                    style={{
                        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                        margin: '0',
                        textAlign: 'right'
                    }}
                    className='mb-3'
                >
                    {post?.date?.toDate().toLocaleDateString()}
                </p>
            </div>

            <div className="p-3 bg-black">
                <div className="container py-3">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-8 text-center text-md-start">
                            <h3 className="text-dancing-script mb-0" style={{ fontSize: 'clamp(1.2rem, 2vw, 1.4rem)', color: 'white' }}>
                                Theo dõi An Classical trên các nền tảng xã hội để không bỏ lỡ những cập nhật mới nhất
                            </h3>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="d-flex flex-row justify-content-center justify-content-md-end">
                                <Link>
                                    <img
                                        src={'/tiktok_logo_white.png'}
                                        alt="tiktok"
                                        width="50"
                                        height="50"
                                        className="me-3 social-icon"
                                    /></Link>
                                <Link>
                                    <img
                                        src={'/fb_logo.png'}
                                        alt="facebook"
                                        width="50"
                                        height="50"
                                        className='me-3 social-icon'
                                    /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white">
                <div className="container py-3">
                    {/* Thanh tiêu đề */}
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <h4 className="text-black m-0">Có thể bạn quan tâm</h4>

                        <Link
                            to={'/knowledge'}
                            className="btn btn-light btn-all"
                        >
                            Xem tất cả
                        </Link>
                    </div>
                </div>

                {/* Hiển thị 3 item nằm ngang */}
                <div className="container">
                    <div className="row">
                        {/* Chỉ hiển thị 3 bài post */}
                        <div className="col-12 col-md-4">
                            <div className="post-item position-relative">
                                {/* Avatar của bài post */}
                                <img
                                    src={posts[0]?.avatar || ''}
                                    alt={posts[0]?.title || ''}
                                    className="img-fluid post-avatar"
                                />

                                {/* Hiển thị thông tin khi hover */}
                                <div className="post-overlay d-flex flex-column justify-content-center align-items-center p-3">
                                    <h5 className="text-white">{posts[0]?.title || ''}</h5>
                                    <p className="text-white">{posts[0]?.subtitle || ''}</p>
                                    <button className="btn btn-light btn-custom">Xem chi tiết</button>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-4">
                            <div className="post-item position-relative">
                                {/* Avatar của bài post */}
                                <img
                                    src={posts[1]?.avatar || ''}
                                    alt={posts[1]?.title || ''}
                                    className="img-fluid post-avatar"
                                />

                                {/* Hiển thị thông tin khi hover */}
                                <div className="post-overlay d-flex flex-column justify-content-center align-items-center p-3">
                                    <h5 className="text-white">{posts[1]?.title || ''}</h5>
                                    <p className="text-white">{posts[1]?.subtitle || ''}</p>
                                    <button className="btn btn-light btn-custom">Xem chi tiết</button>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-4">
                            <div className="post-item position-relative">
                                {/* Avatar của bài post */}
                                <img
                                    src={posts[2]?.avatar || ''}
                                    alt={posts[2]?.title || ''}
                                    className="img-fluid post-avatar"
                                />

                                {/* Hiển thị thông tin khi hover */}
                                <div className="post-overlay d-flex flex-column justify-content-center align-items-center p-3">
                                    <h5 className="text-white">{posts[2]?.title || ''}</h5>
                                    <p className="text-white">{posts[2]?.subtitle || ''}</p>
                                    <button className="btn btn-light btn-custom">Xem chi tiết</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default PostDetail